<template>
  <template-layout :breadCrumbList="breadcrumbComputed" v-if="memberInformation">
    <div class="py-12 px-4">
      <nav class="mb-2 flex flex-wrap justify-between">
        <h1 class="text-2xl text-theme-1">
          รายละเอียดสมาชิก
        </h1>
        <div class="flex flex-wrap">
           <div class="information-value flex flex-wrap mr-2" :title="getSystemNameByField('VSMART')+`${
    memberInformation?.linking_system?.find(i => i.system === 'VSMART')?.updated_at 
    ? '\nข้อมูล ณ วันที่: ' + memberInformation.linking_system.find(i => i.system === 'VSMART').updated_at 
    : ''
  }`" v-show="memberInformation?.linking_system?.some(item => item.system === 'VSMART')">
          <div class="inline-block w-9 h-9" >
          <div class="bg-gray-100 rounded-full text-center w-9 h-9 mr-2 mt-2 overflow-hidden" style="border:1px solid lightpink;">
            <img  class="connection-tags" :src="require('@/assets/images/logo/VSMART.png')">
          </div>
          </div>
          </div>
            <div class="information-value flex flex-wrap mr-2"
            :title="getSystemNameByField('DEP')+`${
    memberInformation?.linking_system?.find(i => i.system === 'DEP')?.updated_at 
    ? '\nข้อมูล ณ วันที่: ' + memberInformation.linking_system.find(i => i.system === 'DEP').updated_at 
    : ''
  }`" v-show="memberInformation?.linking_system?.some(item => item.system === 'DEP')">
          <div class="inline-block w-9 h-9" >
          <div class="bg-gray-100 rounded-full text-center w-9 h-9 mr-2 mt-2 overflow-hidden" style="border:1px solid lightpink;">
    <img class="connection-tags" :src="require('@/assets/images/icon/main/issue_based/disabled.png')">
</div>
          </div>
          </div>
          <!-- <GenerateOtherSystemConnection v-if="memberInformation" :info-data="memberInformation" @update-profile="getMemberInformation" class="mr-2"/> -->
           <GenerateOtherSystemConnection 
    v-if="memberInformation" 
    :key="`generate-${memberInformation._id}-${memberInformationUpdateKey}`"
    :info-data="memberInformation" 
    @update-profile="handleUpdateProfile" 
    class="mr-2 mt-2 flex"
  />
          <button
            class="btn btn-danger mr-2 mt-2"
            @click="deleteProfile"
            data-test="delete-family-modal"
            v-if="(!memberInformation.is_hh_head && !memberInformation.is_fam_head && (currentUser == memberInformation.case_manager?.uid || currentUser == memberInformation?.volunteer.uid)) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('delete-member'))"
          >
            <Trash2Icon class="h-3 w-3 mr-2" />
            ลบ
          </button>
          <GenerateMemberPdf v-if="memberInformation && !getAllowActionByCurrRole('disabled-member-download')" :info-data="memberInformation" class="mr-2 mt-2"/>
         <!-- <CheckInfoWithBORA :edit-data="memberInformation" v-if="memberInformation" class="mr-2"/> -->
          <!-- <CheckInfoWithBORA :edit-data="memberInformation" @update-profile="getMemberInformation" v-if="memberInformation && ((currentUser == memberInformation?.case_manager?.uid || currentUser == memberInformation?.volunteer.uid) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('edit-member'))) && memberInformation?.nationality === 'ไทย' && memberInformation.national_id" class="mr-2"/> -->
          <!-- <EditMemberProfileStep1Modal :step-edit="'ข้อมูลทั่วไป'" :edit-data="memberInformation" @update-profile="getMemberInformation" v-if="memberInformation && ((currentUser == memberInformation?.case_manager?.uid || currentUser == memberInformation?.volunteer.uid) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('edit-member'))) "/> -->
        <EditMemberProfileStep1Modal 
        class="mt-2"
    :step-edit="'ข้อมูลทั่วไป'" 
    :key="`edit-${memberInformation?._id}-${memberInformationUpdateKey}`"
    :edit-data="memberInformation" 
    @update-profile="handleUpdateProfile" 
    v-if="memberInformation && ((currentUser == memberInformation?.case_manager?.uid || currentUser == memberInformation?.volunteer.uid) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('edit-member')))"
  />
        </div>
      </nav>
      <div class="w-1/6 h-1/6 mx-auto" v-if="memberInformationLoading">
        <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
      </div>
      <template v-else>
        <div class="mb-5 flex flex-col lg:flex-row">
          <div
            class="box shadow-md flex flex-col justify-center items-center py-4 px-8 lg:w-max w-full"
          >
            <!-- photo profile -->
            <div
              class="relative h-28 w-28 rounded-full p-1 mb-2 flex-shrink-0"
              :class="{
                'bg-theme-41': memberInformation.sex === 'ชาย',
                'bg-theme-36': memberInformation.sex === 'หญิง',
              }"
            >
              <div
                class="h-full w-full rounded-full bg-theme-33 border-4 border-white overflow-hidden"
              >
                <img v-if="memberInformation.image" :src="memberInformation.image.img_url" class="object-cover object-center h-full w-full"/>
                <div
                  class="absolute right-1 bottom-1 bg-theme-1 border-2 border-white rounded-full h-8 w-8 flex justify-center items-center"
                >
                  <!-- <BriefcaseIcon class="h-4 w-4 text-white" /> -->
                  <div
                    class="t-tooltip flex justify-center"
                  >
                    <span class="t-tooltip-text">
                      {{
                        `${
                          calculateAgeComputed <= 6 ? 'เด็กเล็ก (0 - 6 ปี)'
                          : calculateAgeComputed > 6 && calculateAgeComputed <= 12 ? 'เด็ก (6 ปีขึ้นไป - 12 ปี)'
                          : calculateAgeComputed > 12 && calculateAgeComputed <= 18 ? 'เด็กโต/วัยรุ่น (12 ปีขึ้นไป - 18 ปี)'
                          : calculateAgeComputed > 18 && calculateAgeComputed <= 59 ? 'ผู้ใหญ่/วัยแรงงาน (18 ปีขึ้นไป - 59 ปี)'
                          : calculateAgeComputed > 59 ? 'ผู้สูงอายุ (60 ปีขึ้นไป)'
                          : ''
                        }`
                      }}
                      </span>
                    <img
                      class="h-5 w-5 "
                      src="@/assets/images/icon/baby-boy.png"
                      v-if="calculateAgeComputed <= 6"
                    />
                    <img
                      class="h-5 w-5 "
                      src="@/assets/images/icon/kid.png"
                      v-else-if="calculateAgeComputed > 6 && calculateAgeComputed <= 12"
                    />
                    <img
                      class="h-5 w-5 "
                      src="@/assets/images/icon/teenager.png"
                      v-else-if="calculateAgeComputed > 12 && calculateAgeComputed <= 18"
                    />
                    <img
                      class="h-5 w-5 "
                      src="@/assets/images/icon/man.png"
                      v-else-if="calculateAgeComputed > 18 && calculateAgeComputed <= 59"
                    />
                    <img
                      class="h-5 w-5 "
                      src="@/assets/images/icon/old-man.png"
                      v-else
                    />
                  </div>
                </div>
              </div>
            </div>
            <h3 class="text-lg font-semibold text-theme-37">
              {{
                `${memberInformation.title ? memberInformation.title : ""}${
                  memberInformation.name ? memberInformation.name : ""
                } ${
                  memberInformation.surname ? memberInformation.surname : ""
                }${
                  !!memberInformation.title &&
                  !!memberInformation.name &&
                  !!memberInformation.surname
                    ? ""
                    : "-"
                }`
              }}
            </h3>
            <div class="flex flex-row">
              <span class="text-sm font-normal text-theme-37 mr-3">
                เลขบัตรประจำตัวประชาชน (4 ตัวท้าย)
                <span class="text-sm font-normal text-theme-1">
                  {{
                    memberInformation.national_id
                      ? memberInformation.national_id.slice(-4)
                      : "-"
                  }}
                </span>
              </span>
            </div>
            <div class="flex flex-row mt-3">
              <div
                class="rounded-full px-2 py-1 bg-theme-44 mr-2 flex justify-center items-center"
                v-if="memberInformation.is_hh_head"
              >
                <p class="font-normal text-xs text-theme-1 whitespace-nowrap">
                  หัวหน้าครัวเรือน
                </p>
              </div>
              <div
                class="rounded-full px-2 py-1 bg-theme-44 flex justify-center items-center"
                v-if="memberInformation.is_fam_head"
              >
                <p class="font-normal text-xs text-theme-1 whitespace-nowrap">
                  หัวหน้าครอบครัว
                </p>
              </div>
            </div>
          </div>

          <div
            class="flex-grow grid grid-cols-1 md:grid-cols-2 px-8 py-8 gap-6"
          >
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">
                  วัน/เดือน/ปีเกิด
                </p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ birthdateComputed }} (อายุ {{calculateAgeComputed}} ปี)
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">เบอร์โทรศัพท์</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.mobile_num
                      ? memberInformation.mobile_num
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item problem md:col-span-2">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สภาพปัญหา</p>
              </div>
              <div class="information-value flex flex-wrap">
                <CheckboxIconButton
                  class="mr-0.5"
                  icon="MapPinIcon"
                  id="mapPin-checkbox"
                  :value="true"
                  v-model="haveProbHousing"
                  disabled
                  tooltip="ปัญหาด้านที่อยู่อาศัย"
                />
                <CheckboxIconButton
                  class="mr-0.5 inline-block"
                  icon="HeartIcon"
                  id="Heart-checkbox"
                  :value="true"
                  v-model="haveProbHealth"
                  disabled
                  tooltip="ปัญหาด้านสุขภาพ"
                />
                <CheckboxIconButton
                  class="mr-0.5"
                  icon="BookOpenIcon"
                  id="BookOpen-checkbox"
                  :value="true"
                  v-model="haveProbEducation"
                  disabled
                  tooltip="ปัญหาด้านการศึกษา"
                />
                <CheckboxIconButton
                  class="mr-0.5"
                  icon="DollarSignIcon"
                  id="DollarSignIcon-checkbox"
                  :value="true"
                  v-model="haveProbOccupation"
                  disabled
                  tooltip="ปัญหาด้านการเงิน"
                />
                <CheckboxIconButton
                  class="mr-0.5"
                  icon="HomeIcon"
                  id="HomeIcon-checkbox"
                  :value="true"
                  v-model="haveProbFamily"
                  disabled
                  tooltip="ปัญหาด้านครัวเรือน"
                />
                <CheckboxIconButton
                  class="mr-0.5"
                  id="fighting-checkbox"
                  :value="true"
                  v-model="haveProbViolence"
                  disabled
                  tooltip="ปัญหาด้านความรุนแรงในครอบครัว/สังคม"
                >
                  <img
                    class="w-4 h-4 ml-1"
                    src="@/assets/images/icon/boxing-glove.png"
                    alt="boxing-glove-icon"
                  />
                </CheckboxIconButton>
                <CheckboxIconButton
                  class="mr-0.5"
                  id="someheart-checkbox"
                  :value="true"
                  v-model="haveProbHumanTrafficking"
                  disabled
                  tooltip="ปัญหาด้านการเป็นผู้เสียหายจากการค้ามนุษย์"
                >
                  <img
                    class="w-4 h-4"
                    src="@/assets/images/icon/payment-method.png"
                    alt="paymemt-method-icon"
                  />
                </CheckboxIconButton>
                <CheckboxIconButton
                  class="mr-0.5"
                  icon="PackageIcon"
                  id="somePackage-checkbox"
                  :value="true"
                  v-model="haveProbAccesibility"
                  disabled
                  tooltip="ปัญหาด้านการเข้าถึงสิทธิ"
                >
                  <img
                    src="@/assets/images/icon/id-card.png"
                    alt="id-card-icon"
                    class="w-4 h-4"
                  />
                </CheckboxIconButton>
                <CheckboxIconButton
                  class="mr-0.5"
                  icon="CloudLightningIcon"
                  id="CloudLightningIcon-checkbox"
                  :value="true"
                  v-model="haveProbOthers"
                  disabled
                  tooltip="อื่นๆ"
                />
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">เพศ</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.sex
                      ? memberInformation.sex
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ศาสนา</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.religion
                      ? memberInformation.religion
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สัญชาติ</p>
              </div>
              <div class="information-value">
                <!--if national id set nationality เป็นไทย-->
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.national_id ? "ไทย"
                    : memberInformation.nationality
                      ? memberInformation.nationality == "อื่นๆ"
                        ? memberInformation.nationality_other
                          ? memberInformation.nationality_other
                          : "-"
                        : "-"
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สถานะ</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.vital_status?.valueOf() != undefined
                    ? memberInformation.marital_status
                      ? memberInformation.marital_status
                      : "เสียชีวิต"
                    : "-"
                  }}
                </p>
              </div>
            </div>
            <!-- <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ปัญหาสุขภาพ</p>
              </div>
              <div class="flex flex-wrap information-value">
                <p
                  v-if="
                    !memberInformation.have_pwd_card &&
                      !memberInformation.is_disabled
                  "
                >
                  -
                </p>
                <div
                  v-if="memberInformation.have_pwd_card"
                  class="bg-theme-36 px-2 py-1 m-1 text-white rounded-full flex justify-center items-center whitespace-nowrap"
                >
                  ไม่มีบัตรผู้พิการ
                </div>
                <div
                  v-if="false"
                  class="bg-theme-45 px-2 py-1 m-1 text-white rounded-full flex justify-center items-center"
                >
                  ผู้ป่วยเรื้อรัง
                </div>
                <div
                  v-if="memberInformation.is_disabled"
                  class="bg-theme-45 px-2 py-1 m-1 text-white rounded-full flex justify-center items-center"
                >
                  ผู้พิการซ้ำซ้อน
                </div>
              </div>
            </div> -->
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">การศึกษา</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  <!-- edu_status แสดงข้อมูลสถานะการศึกษาเพิ่ม -->
                  {{
                    memberInformation.edu_level
                      ? memberInformation.edu_level.desc
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สถานะการศึกษา</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  <!-- edu_status แสดงข้อมูลสถานะการศึกษาเพิ่ม -->
                  {{
                    memberInformation.edu_status
                      ? memberInformation.edu_status.desc
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item col-span-2">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">
                  กิจกรรมที่เข้าร่วม
                </p>
              </div>
              <div class="information-value">
                <div class="flex flex-wrap">
                  <template v-if="memberInformation.attend_socact">
                    <p
                      class="font-normal text-base text-theme-1"
                      v-for="(item, index) in memberInformation.attend_socact"
                      :key="item.code"
                    >
                      {{
                        `${item.desc ? item.desc : "-"}${(index != memberInformation.attend_socact.length - 1) ? ",&nbsp;" : ""}`
                      }}
                    </p>
                  </template>
                  <template v-else>
                    <p class="font-normal text-base text-theme-1">-</p>
                  </template>
                </div>
              </div>
            </div>
            <hr class="md:col-span-2" v-show="memberInformation?.csg?.status || memberInformation?.csg?.registrant_type" />
            <div class="md:col-span-2" v-show="memberInformation?.csg?.status || memberInformation?.csg?.registrant_type"><p class="font-normal text-base text-theme-1">ข้อมูลเด็กแรกเกิด</p></div>
            <!-- <div class="information-item" v-show="memberInformation?.csg?.registrant_type">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ประเภทผู้ลงทะเบียน</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.csg?.registrant_type ?? "-"
                  }}
                </p>
              </div>
            </div> -->
            <div class="information-item" v-show="memberInformation?.csg?.status">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สถานะเด็ก</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.csg?.status ?? "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-show="memberInformation?.csg?.register_status">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สถานะลงทะเบียน</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.csg?.register_status ?? "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-show="memberInformation?.csg?.registrant_type">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ประเภทผู้ลงทะเบียน</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.csg?.registrant_type ?? "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-show="memberInformation?.parent&& memberInformation?.csg?.registrant_type =='ผู้ปกครอง'">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ผู้ปกครอง</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ ((memberInformation?.parent?.title?? "-")+' '+(memberInformation?.parent?.name?? "-")+' '+(memberInformation?.parent?.surname?? "-"))
                  }}
                </p>
              </div>
            </div>
            <!-- <hr class="md:col-span-2" v-show="memberInformation?.dep?.person_subtype || memberInformation?.dep?.permit_date" />
            <div class="md:col-span-2" v-show="memberInformation?.dep?.person_subtype || memberInformation?.dep?.permit_date"><p class="font-normal text-base text-theme-1">ข้อมูลทะเบียนคนพิการ</p></div>
            <div class="information-item" v-show="memberInformation?.dep?.person_subtype">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สถานะ</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.dep?.person_subtype ?? "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-show="memberInformation?.dep?.permit_date">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">วันที่อนุมัติขึ้นทะเบียน</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.dep?.permit_date ?? "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-show="memberInformation?.dep?.card_issue_date">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">วันที่ออกบัตร</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.dep?.card_issue_date ?? "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-show="memberInformation?.dep?.card_expire_date">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">วันที่บัตรหมดอายุ</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ memberInformation?.dep?.card_expire_date ?? "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-show="memberInformation?.dep?.curator_first_name">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ผู้ดูแลคนพิการ</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{ ((memberInformation?.dep?.curator_prefix_name?? "-")+' '+(memberInformation?.dep?.curator_first_name?? "-")+' '+(memberInformation?.dep?.curator_last_name?? "-") +' ('+(memberInformation?.dep?.curator_relation_name || memberInformation?.dep?.curator_relation_other || "-")+')')
                  }}
                </p>
              </div>
            </div> -->
            <hr class="md:col-span-2" />
            <div class="md:col-span-2"><p class="font-normal text-base text-theme-1">ข้อมูลบิดา</p></div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ชื่อ-สกุล</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.father
                      ? `${memberInformation.father.title} ${memberInformation.father.name} ${memberInformation.father.surname}`
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สัญชาติ</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.father ?
                      memberInformation.father.nationality == "อื่นๆ" ? memberInformation.father.nationality_other ? memberInformation.father.nationality_other : "-" : memberInformation.father.nationality
                    : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-if="memberInformation.father ?
                      memberInformation.father.nationality == 'ไทย':false">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">เลขบัตรประจำตัวประชาชน</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.father ?
                      memberInformation.father.national_id ? memberInformation.father.national_id : "-"
                    : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สถานะการมีชีวิต</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.father?
                      memberInformation.father.vital_status
                      ? "มีชีวิตอยู่"
                      : "เสียชีวิต"
                    : "-"
                  }}
                </p>
              </div>
            </div>
            <hr class="md:col-span-2" />
            <div class="md:col-span-2"><p class="font-normal text-base text-theme-1">ข้อมูลมารดา</p></div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">ชื่อ-สกุล</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.mother
                      ? `${memberInformation.mother.title} ${memberInformation.mother.name} ${memberInformation.mother.surname}`
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สัญชาติ</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.mother ?
                      memberInformation.mother.nationality == "อื่นๆ" ? memberInformation.mother.nationality_other ? memberInformation.mother.nationality_other : "-" : memberInformation.mother.nationality
                    : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item" v-if="memberInformation.mother ?
                      memberInformation.mother.nationality == 'ไทย':false">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">เลขบัตรประจำตัวประชาชน</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.mother ?
                      memberInformation.mother.national_id ? memberInformation.mother.national_id : "-"
                    : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="information-item">
              <div class="information-label">
                <p class="font-normal text-base text-theme-37">สถานะการมีชีวิต</p>
              </div>
              <div class="information-value">
                <p class="font-normal text-base text-theme-1">
                  {{
                    memberInformation.mother ?
                    memberInformation.mother.vital_status
                      ? "มีชีวิตอยู่"
                      : "เสียชีวิต"
                    : "-"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="box shadow-md rounded-lg tab-content">
          <CustomTab
            @currentTab="changeTab"
            :id="'problem-tab'"
            :currentTabText="currentTabText"
            :TabArray="[
              {tab: IncomeTab, name: 'รายได้'},
              {tab: HealthTab, name: 'สุขภาพ'},
              {tab: BenefitTab, name: 'สวัสดิการ'},
              {tab: ProblemTab, name: 'ปัญหา'},
            ]"
          >
            <template v-slot:nav-right>
              <div class="text-center">
                <a
                  class="btn btn-primary"
                  href="javascript:;"
                  @click="openEditModal"
                  v-if="memberInformation && ((currentUser == memberInformation?.case_manager?.uid || currentUser == memberInformation?.volunteer.uid) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('edit-member'))|| (getCurrentRole() == 'cm' && currentTabText == 'ปัญหา')) "
                >
                  <Edit2Icon class="h-3 w-3 mr-1" />
                  แก้ไข
                </a>
              </div>
            </template>
            <template v-slot:tab-content>
              <component v-bind:is="currentTab" :information="memberInformation" />
            </template>
          </CustomTab>
        </div>
        <div class="mt-2">
          <h1 class="text-2xl text-theme-1 my-4"> สรุปสภาพปัญหาความเดือดร้อน </h1>
          <div class="mt-8">
            <CustomAccordion
              :isOpen="true"
              :iconText="false"
              :accordion-id="`${acc.tab}`"
              customMode
              v-for="acc in summaryArray"
              :key="acc"
            >
              <template v-slot:header-content>
                <!-- <div class="text-base font-semibold text-theme-37">{{'สวัสดี'}}</div> -->
                <div class="text-base font-semibold text-theme-37">{{acc.name}}</div>
              </template>
              <template v-slot:body-content>
                <hr>
                <SummaryTab :dataList="memberInformation" :activeTab="acc.tab" @updateProbSummary="getMemberInformation"/>
              </template>
            </CustomAccordion>
          </div>
        </div>
      </template>
    </div>
    <EditMemberProfileModal :openModalStatus="openModalStatus" :current-tab="currentTabText" :edit-data="memberInformation" @update-profile="getMemberInformation" @clear-modal-value="resetModalValue"/>
  </template-layout>
</template>

<script setup>
import { shallowRef, ref, onMounted, computed, watch, reactive,provide } from "vue";
import ProblemTab from "./container/ProblemTab.vue";
import BenefitTab from "./container/BenefitTab.vue";
import HealthTab from "./container/HealthTab.vue";
import IncomeTab from "./container/IncomeTab.vue";
import CheckboxIconButton from "@/components/base/checkbox-icon-button/index.vue";
// import HistoryModal from "./container/HistoryModal.vue";
import EditMemberProfileModal from "./container/EditMemberProfileModal.vue";
import EditMemberProfileStep1Modal from "./container/EditMemberProfileStep1Modal.vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import axios from "axios";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import SummaryTab from "./container/SummaryProblem.vue"
import CustomTab from "@/components/tabs/index.vue"
import Swal from "sweetalert2";
import CustomAccordion from "@/components/base/custom-accordion/index.vue";
import GenerateMemberPdf from "./container/GenerateMemberPdf.vue";
import GenerateOtherSystemConnection from "./container/GenerateOtherSystemConnection.vue";
// import GenerateOtherSystemConnectionBORA from "@/views/member/container/GenerateOtherSystemConnectionBORA.vue";
import { getAllowActionByCurrRole, getCurrentRole } from "@/utils/get-roles"

import OtherSystemList from "@/data/other_system_list.json";

// https://storage.thaisme.one/mso/api/v1/view/member.json
var md5 = require('md5');
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
const router = useRouter()
const store = useStore();
const route = useRoute();
const currentTab = shallowRef(IncomeTab);
const iconActive = ref(true);
const currentTabText = ref("รายได้");
// const currentSummaryTabText = ref("มิติสุขภาพ");
const memberInformation = ref(null);
const memberInformationLoading = ref(true)
const openModalStatus = ref(false)

const memberInformationUpdateKey = ref(0);
const handleUpdateProfile = async () => {
  if (memberInformationLoading.value) return;
  await getMemberInformation();
};
// const currentSummaryTab = ref("prob_health")
const summaryArray = reactive([
  {tab: 'prob_health', name: 'มิติสุขภาพ'},
  {tab: 'prob_family', name: 'มิติความเป็นอยู่'},
  {tab: 'prob_education', name: 'มิติการศึกษา'},
  {tab: 'prob_occupation', name: 'มิติรายได้'},
  {tab: 'prob_accesibility', name: 'มิติการเข้าถึงบริการรัฐ'},
])

const birthdateComputed = computed(() => {
  if (memberInformation.value.birthdate) {
    const date = new Date(memberInformation.value.birthdate);
    const result = date.toLocaleDateString("th-TH", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return result;
  }
  return "-";
});
function getSystemNameByField(fieldCode) {
    const system = OtherSystemList.find(item => item.field === fieldCode);
    return system ? system.name : "ไม่พบระบบที่เชื่อมโยง";
}

onMounted(() => {
  getMemberInformation();
});
const getMemberInformation = async () => {
  memberInformationLoading.value = true;
  const token = store.getters["userAuth/getToken"];
  const url = `${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
  };
    try {
  const res = await axios.post(url, { memberId: route.params.mid }, { headers });
  memberInformationLoading.value = false;
  if (res.status === 200) {
    memberInformation.value = res.data;
    memberInformationUpdateKey.value++;
  } else {
      throw new Error(`Unexpected status: ${res.status}`);
  }
  } catch (error) {
    memberInformationLoading.value = false;
    Swal.fire({
      icon: "warning",
      text: "ระบบผิดพลาด",
    });
  }
};
provide('refreshMemberData', handleUpdateProfile);

const calculateAge = (birthdate) =>{ 
  var diff_ms = Date.now() - birthdate.getTime();
  var age_dt = new Date(diff_ms); 
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}
const haveProbHousing = computed(()=>{
  return  memberInformation.value.prob_housing?.length>0
})
const haveProbAccesibility = computed(()=>{
  return  memberInformation.value.prob_accesibility?.length>0
})
const haveProbEducation = computed(()=>{
  return  memberInformation.value.prob_education?.length>0
})
const haveProbFamily = computed(()=>{
  return  memberInformation.value.prob_family?.length>0
})
const haveProbHealth = computed(()=>{
  return  memberInformation.value.prob_health?.length>0
})
const haveProbHumanTrafficking = computed(()=>{
  return  memberInformation.value.prob_human_trafficking?.length>0
})
const haveProbOccupation = computed(()=>{
  return  memberInformation.value.prob_occupation?.length>0
})
const haveProbOthers = computed(()=>{
  return  memberInformation.value.prob_others?.length>0
})
const haveProbViolence = computed(()=>{
  return  memberInformation.value.prob_violence?.length>0
})
const calculateAgeComputed = computed(()=>{
  return calculateAge(new Date(memberInformation.value.birthdate))
})
const breadcrumbComputed = computed(()=>{
  let array =[{
    name: "ครัวเรือน",
    path: "main-house-hold",
  }]
  if(memberInformation.value.hh_id){
    array.push({
      name: "ข้อมูลครัวเรือน",
      path: "household-profile",
      param: { hhid: memberInformation.value.hh_id },
    })
  }
  if(memberInformation.value.fam_id){
    array.push({
      name: "ข้อมูลครอบครัว",
      path: "family-profile",
      param: { famid: memberInformation.value.fam_id },
    })
  }
  if(memberInformation.value._id){
    array.push({
      name: "บุคคล",
      active: true,
    })
  }
  return array
})

const changeTab = (tabObj) => {
  currentTab.value = tabObj.tab;
  currentTabText.value = tabObj.text;
  openModalStatus.value = false
};
// const summaryTabChange = (tab) =>{
//   currentSummaryTab.value = tab.tab;
//   currentSummaryTabText.value = tab.text
// }

const openEditModal = ()=>{
  openModalStatus.value = true
}
const resetModalValue = ()=>{
  openModalStatus.value = false
}
const deleteProfile = ()=>{
  const token = store.getters["userAuth/getToken"];
  swalCustom.fire({
    text:"ยืนยันลบข้อมูล",
    icon:"warning",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: 'ตกลง',
    cancelButtonText: 'ยกเลิก',
  }).then(async (result)=>{
    if(result.isConfirmed){
      if(!memberInformation.value.is_hh_head && !memberInformation.value.is_fam_head){
        const config = {
          url: `${process.env.VUE_APP_BASE_API}member/${memberInformation.value._id}`,
          method: "PUT",
          headers:{
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
          },
          data:{
            update:{
              status: "removed",
              modified_by: store.getters["userInfo/getUserInfoForApi"],
              msoid: md5(Date.now())
            }
          }
        }
        try{
          const response = await axios(config)
          if(response){
            swalCustom.fire({
              text:"สำเร็จ",
              icon: 'success',
              timer: 3000,
              confirmButtonText: "ปิด",
            }).then(() => {
              router.push({
                name: 'member-page',
              })
            });
          }
        }
        catch(error){
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
          console.log(error);
        }
      }
      else{
        swalCustom.fire({
          text: "ไม่สามารถลบได้",
          icon: "warning",
          //timer: 3000, //timeOut for auto-close
          confirmButtonText: "ปิด",
        });

      }
    }
  })

}
const currentUser = computed(()=>{
  return store.getters["userAuth/getUsername"]
})

</script>

<style lang="scss" scoped>
.information-item {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  .information-label {
    width: 130px;
  }
  .information-value {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
.information-item.problem {
  align-items: center;
}
.tab-content {
  min-height: 24rem;
}
.box-card{
    display: flex;
    flex-wrap: wrap;
    column-gap: 3px;
    flex-direction: row;
    row-gap: 3px;
    justify-content: center;
}
</style>
